__turbopack_context__.v({
  "className": "dm_sans_9b8759b1-module__t9nXWG__className",
});
